// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jG8D","right":"styles_right__nFXzV"};